<div class="container mt-4 mb-5">
  <h4 i18n>Novo Cliente</h4>
  <novo-cliente [cadastroCliente]="true" [lgpdCheck]="false"></novo-cliente>
</div>
